import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Users, Vote, BarChart3, ArrowLeft } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import { api } from "@/lib/api";
import QuestionCard from "@/components/QuestionCard";
import { Card } from "@/components/ui/card";

export default function CountryPage() {
  const { code } = useParams();
  const { t, lang } = useI18n();
  const [country, setCountry] = useState(null);
  const [committees, setCommittees] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/countries").then(({ data }) => setCountry(data.find((c) => c.code === code)));
    api.get("/committees", { params: { country: code } }).then(({ data }) => setCommittees(data));
    api.get("/questions", { params: { country: code } }).then(({ data }) => setQuestions(data));
    api.get("/stats", { params: { country: code } }).then(({ data }) => setStats(data));
  }, [code]);

  const cName = country ? (lang === "it" ? country.name_it : country.name_en) : code;

  return (
    <div className="max-w-6xl mx-auto px-4 py-10">
      <Link to="/countries" data-testid="back-countries" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground mb-4"><ArrowLeft className="h-4 w-4" />{t("common.back")}</Link>
      <h1 className="font-heading text-4xl font-black tracking-tighter">{cName}</h1>

      {stats && (
        <div className="grid grid-cols-3 gap-4 mt-6">
          {[{ i: Vote, k: "home.stats.questions", v: stats.questions }, { i: BarChart3, k: "home.stats.votes", v: stats.votes }, { i: Users, k: "home.stats.citizens", v: stats.verified_citizens }].map((s) => (
            <div key={s.k} className="rounded-lg border border-border bg-card p-4">
              <s.i className="h-5 w-5 text-primary mb-2" />
              <div className="font-heading text-2xl font-black">{s.v}</div>
              <div className="text-xs uppercase tracking-wider text-muted-foreground">{t(s.k)}</div>
            </div>
          ))}
        </div>
      )}

      <h2 className="font-heading text-xl font-bold mt-10 mb-4 flex items-center gap-2"><Users className="h-5 w-5 text-primary" />{t("country.committees")}</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {committees.map((c) => (
          <Card key={c.id} data-testid={`committee-${c.id}`} className="p-5"><div className="font-heading font-bold">{c.name}</div><p className="text-sm text-muted-foreground mt-1">{c.description}</p></Card>
        ))}
        {committees.length === 0 && <p className="text-muted-foreground text-sm">—</p>}
      </div>

      <h2 className="font-heading text-xl font-bold mt-10 mb-4 flex items-center gap-2"><Vote className="h-5 w-5 text-primary" />{t("country.questions")}</h2>
      {questions.length === 0 ? <p className="text-muted-foreground">{t("home.empty")}</p> : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">{questions.map((q, i) => <QuestionCard key={q.id} q={q} index={i} />)}</div>
      )}
    </div>
  );
}
